<template>
  <div class="home">
    <Auth :appLogo="appLogo" :appTitle="appTitle" :sudirState="sudirState" />
  </div>
</template>

<script>
// @ is an alias to /src
import Auth from '@/components/Auth.vue'

export default {
  props:['appLogo', 'appTitle', 'sudirState'],
  name: 'AuthView',
  components: {
    Auth
  }
}
</script>
